import React from 'react';
import { ComponentWrapper } from '../../helperComponents/componentWrapper/ComponentWrapper';
import { View } from 'react-native';
import { Header } from './Shared/Header';
import { NotificationGrid } from './components/notifications/NotificationGrid';

const Notifications = () => {
    return (
        <ComponentWrapper
            containerStyle={[{ flex: 1, backgroundColor: '#F8F8F8' }]}
        >
            <Header />
            <View style={{ flex: 1, paddingHorizontal: 20 }}>
                <NotificationGrid />
            </View>
        </ComponentWrapper>
    );
};

export { Notifications };
